import objectFitImages from 'object-fit-images';

export default class LazyLoad {
    static initImg() {
        if ('loading' in HTMLImageElement.prototype) {
            const images = document.querySelectorAll('img[loading="lazy"], source');
            images.forEach((img) => {
                if (img.dataset.src) {
                    img.src = img.dataset.src;
                    img.removeAttribute('data-src');
                }

                if (img.dataset.srcset) {
                    img.srcset = img.dataset.srcset;
                    img.removeAttribute('data-srcset');
                }
            });

            return Promise.resolve();
        }

        return import('lazysizes').then((module) => {
            document.addEventListener('lazyloaded', (e) => {
                objectFitImages(e.target);
            });
        });
    }

    static initVideo() {
        document.addEventListener('DOMContentLoaded', function() {
            const lazyVideos = [].slice.call(document.querySelectorAll('video[loading="lazy"]'));

            if ('IntersectionObserver' in window) {
                const lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
                    entries.forEach(function(video) {
                        if (video.isIntersecting) {
                            for (const source in video.target.children) {
                                const videoSource = video.target.children[source];
                                if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                                    videoSource.src = videoSource.dataset.srcVideo;
                                }
                            }

                            video.target.load();
                            video.target.classList.remove('lazy');
                            lazyVideoObserver.unobserve(video.target);
                        }
                    });
                });

                lazyVideos.forEach(function(lazyVideo) {
                    lazyVideoObserver.observe(lazyVideo);
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./assets/js/common/modules/lazy-load.js